import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=6940889c"
import script from "./OrderRecord.vue?vue&type=script&lang=js"
export * from "./OrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports